import classnames from 'classnames';
import React from 'react';

interface ToggleProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  className?: string;
  label?: string | null;
  dataTestId?: string | null;
}

export default function Toggle({
  className,
  label = null,
  dataTestId = null,
  ...inputProps
}: ToggleProps) {
  return (
    <label className={classnames('DSToggle', className)}>
      <input {...inputProps} type="checkbox" />
      <span
        data-test-id={dataTestId ?? undefined}
        className="DSToggle__slider"
      />
      {label && <span className="ml2">{label}</span>}
    </label>
  );
}
